export const DividerFlipped = ({className}) => {
    return(
    <div className="flex flex-row place-items-center w-full">
        <div className ="flex-grow border-b-[1px] border-gray-400"></div>
        <div className ={`border-[2px] border-[#a44474] ${className}`}></div>
    </div>
    )
}